module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-content--card",
    class: _vm.appointment.orderStatus
  }, [_c('div', {
    staticClass: "full-w flex space-between margin-b-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.getTimeRange(_vm.appointment)) + " " + _vm._s(_vm.appointment.orderStatus === 'cancelled' ? ("(" + (_vm.appointment.orderStatus) + ")") : ''))]), _vm._v(" "), (_vm.edit && _vm.appointment.orderStatus !== 'cancelled') ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.appointment)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.edit')))]) : _c('div', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "full-w flex"
  }, [_c('span', {
    staticClass: "point-content--client"
  }, [_vm._v(_vm._s(_vm.appointment.clientName) + ", " + _vm._s(_vm.appointment.serviceName))])]), _vm._v(" "), (_vm.fade) ? _c('div', {
    staticClass: "point-content--fade full-w"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07251d2a","hasScoped":false}!./src/app/components/appointmentCard/appointmentCard.html
// module id = 2900
// module chunks = 1